import { gql } from "@apollo/client";

export const CREATE_PERFORMANCE = gql`
  mutation CreatePerformance($input: PerformanceInput) {
    createPerformance(input: $input) {
      isSuccess
      message {
        messageKh
        messageEn
      }
    }
  }
`;

export const GET_PERFORMACE_PAGINATION = gql`
  query GetPerformancePagination(
    $page: Int
    $limit: Int
    $keyword: String
    $pagination: Boolean
    $classId: String
    $subjectId: String
  ) {
    getPerformancePagination(
      page: $page
      limit: $limit
      keyword: $keyword
      pagination: $pagination
      classId: $classId
      subjectId: $subjectId
    ) {
      data {
        _id
        description
        remark
        performanceTypeId {
          _id
          khName
          enName
          date
          remark
        }
        studentId {
          _id
          familyName
          studentName
        }
        subjectId {
          _id
          khName
          enName
          remark
        }
      }
      paginator {
        slNo
        prev
        next
        perPage
        totalPosts
        totalPages
        currentPage
        hasPrevPage
        hasNextPage
        totalDocs
      }
    }
  }
`;

export const UPDATE_PERFORMANCE = gql`
  mutation UpdatePerformance($id: ID!, $input: PerformanceInput) {
    updatePerformance(_id: $id, input: $input) {
      isSuccess
      message {
        messageKh
        messageEn
      }
    }
  }
`;

export const DELETE_PERFORMANCE = gql`
  mutation DeletePerformance($id: ID!) {
    deletePerformance(_id: $id) {
      isSuccess
      message {
        messageKh
        messageEn
      }
    }
  }
`;
